import { SVGProps } from 'react';

const ThermometerSnowflake = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m10 20-1.25-2.5L6 18m4-14L8.75 6.5 6 6m4.585 9H10m0 0-3 6m3-6-1.5-3M2 12h6.5m0 0L10 9m0 0L7 3m3 6h2m-8 1 1.5 2L4 14m16 .54a4 4 0 1 1-4 0V4a2 2 0 1 1 4 0z"
    />
  </svg>
);
export default ThermometerSnowflake;
